import apiService from '@/services/apiService';

// BE contract: cmsrevamp routes/cx_report.go — 3 endpoints, all role-gated
// to superadmin/claim_manager. PUT + POST bodies are form-encoded (c.PostForm).
// See dev-specs/2026/Q3/projects/CMS-Revamp-Disbursement-Time-Setting/backend/SPEC.md.

const actions = {
  getDisbursementTime() {
    return new Promise((resolve, reject) => {
      apiService.get('cx/claim-setting/disbursement-time')
        .then(resolve)
        .catch(reject);
    });
  },
  updateDisbursementTime({ commit }, payload) {
    const formData = new FormData();
    formData.append('start_time', payload.start_time);
    formData.append('end_time', payload.end_time);
    return new Promise((resolve, reject) => {
      apiService.put('cx/claim-setting/disbursement-time', formData)
        .then(resolve)
        .catch(reject);
    });
  },
  getDisbursementTimeLogs({ commit }, payload) {
    // BE also supports optional filters: date_from, date_to, changed_by_username.
    // Not surfaced in UI per PRD design — append here if a filter row is added.
    const formData = new FormData();
    formData.append('page', payload && payload.page ? payload.page : 1);
    formData.append('limit', payload && payload.limit ? payload.limit : 10);
    return new Promise((resolve, reject) => {
      apiService.post('cx/claim-setting/disbursement-time/logs/find-with-paging', formData)
        .then(resolve)
        .catch(reject);
    });
  },
};

export default actions;
